import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Filtrar erros de extensões do navegador no console (apenas em desenvolvimento)
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    const errorMessage = args.join(' ');
    // Ignorar erros conhecidos de extensões do navegador
    if (
      errorMessage.includes('adsbygoogle') ||
      errorMessage.includes('googlesyndication') ||
      errorMessage.includes('pagead') ||
      errorMessage.includes('ERR_BLOCKED_BY_CLIENT') ||
      errorMessage.includes('runtime.lastError') ||
      errorMessage.includes('content-scripts') ||
      errorMessage.includes('Could not establish connection') ||
      errorMessage.includes('Receiving end does not exist') ||
      errorMessage.includes('Error getting feature flag') ||
      errorMessage.includes('Error getting tab info') ||
      errorMessage.includes('injection-tss') ||
      errorMessage.includes('TSS: Protection is disabled')
    ) {
      return; // Não exibir esses erros
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



